import { defineComponent as _defineComponent } from 'vue'
import { computed, useContext } from '@nuxtjs/composition-api';
import { GETTERS as GETTERS_WEB3_TOKENS } from '~/store/affility/web3/tokens/names';

interface Props {
    dropdown?: boolean;
}


export default /*#__PURE__*/_defineComponent({
  __name: 'ContractAddresses',
  props: {
    dropdown: { type: Boolean, default: false }
  },
  setup(__props: any) {

const { dropdown } = __props as { dropdown: boolean };



const { store } = useContext();
        
const contracts = computed(() => store.getters[`affility/web3/tokens/${GETTERS_WEB3_TOKENS.MAIN_CONTRACT_ADDRESSES}`]);

return { __sfc: true,dropdown, store, contracts }
}

})